import { WarningTwoTone } from '@ant-design/icons'
import { Space, Tooltip, Typography } from 'antd'

const Warning: React.FC<{ tooltip?: string; visible: boolean }> = ({
  tooltip,
  children,
  visible,
}) => {
  if (visible)
    return (
      <Space size="small" align="baseline">
        <Tooltip title={tooltip}>
          <Typography.Text
            type="warning"
            style={tooltip ? { cursor: 'help' } : undefined}
          >
            <WarningTwoTone twoToneColor={['gold-6', 'none']} />
          </Typography.Text>
        </Tooltip>
        {children}
      </Space>
    )
  return <>{children}</>
}

export default Warning
